import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const IconWrapper = styled.div`
  flex-basis: ${pxToRem('40px')};
  ${props =>
    props.iconInput &&
    css`
      position: absolute;
      right: ${pxToRem('10px')};
    `}
`;

const getIconShowStyles = props => {
  let style;
  switch (props.variant) {
    case 'login':
      style = css`
        color: ${({ theme }) => theme.colors.white};
      `;
      break;
    case 'changeaccountpassword':
    case 'editaccountdata':
    case 'firmware':
      style = css`
        color: ${({ theme }) => theme.colors.mainBlue};
      `;
      break;
    case 'rfid':
      style = css`
        color: ${({ theme }) => theme.colors.blue.one};
      `;
      break;
    default:
      break;
  }
  return style;
};

export const InputControl = styled.input`
  flex: 1 0 auto;
  outline: none;
  border: none;
  background: transparent;
  font-family: ${({ theme }) => theme.fontset.opensans};
  font-size: 1rem;

  ${props =>
      props.variant === 'insertotp' &&
      css`
        width: 100%;
      `}
    :-webkit-autofill,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
`;

const getStyles = props => {
  let style;
  switch (props.variant) {
    case 'login':
      style = css`
        border: ${pxToRem('1px')} solid
          ${() =>
            props.status === 'invalid'
              ? props.theme.colors.semantic.secondary
              : 'rgba(255, 255, 255, 0.8)'};
        background-color: rgba(255, 255, 255, 0.32);

        ${() =>
          props.status !== 'invalid' &&
          css`
            :hover {
              border: ${pxToRem('1px')} solid rgba(255, 255, 255, 0.8);
            }
          `}

        ${() =>
          props.phoneSection &&
          css`
            background: transparent !important;
            border: none !important;
          `}
      `;
      break;
    case 'rfid':
      style = css`
        padding: ${pxToRem('16px')};
        height: ${pxToRem('56px')};
      `;
      break;
    case 'otp':
      style = css`
        border: ${pxToRem('1px')} solid ${props.theme.colors.statusGreen};
        width: ${pxToRem('137px')};
        height: ${pxToRem('56px')};
        background-color: rgba(255, 255, 255, 0.32);
        border: solid ${pxToRem('1px')}
          ${props.status === 'invalid'
            ? props.theme.colors.semantic.secondary
            : 'rgba(255, 255, 255, 0.8)'};
      `;
      break;
    case 'changeaccountpassword':
      style = css`
        width: ${pxToRem('355px')};
        height: ${pxToRem('56px')};
        opacity: 0.4;
        border: ${props.status !== 'invalid'
          ? `${pxToRem('1px')} solid ${props.theme.colors.mainBlue}`
          : `${pxToRem('1px')} solid ${props.theme.colors.semantic.secondary}`};
        ${props =>
          props.value &&
          css`
            opacity: 1;
          `}
      `;
      break;
    case 'insertotp':
      style = css`
        width: ${pxToRem('123px')};
        height: ${pxToRem('50px')};
        opacity: 0.4;
        border: ${props.status !== 'invalid'
          ? `${pxToRem('1px')} solid ${props.theme.colors.mainBlue}`
          : `${pxToRem('1px')} solid ${props.theme.colors.semantic.secondary}`};
        ${props =>
          props.value &&
          css`
            opacity: 1;
          `}
      `;
      break;
    case 'editaccountdata':
      style = css`
        width: ${props.customWidth
          ? pxToRem(`${props.customWidth}px`)
          : pxToRem('431px')};
        height: ${pxToRem('56px')};
        margin: ${pxToRem('10px')};
        padding: 0 ${pxToRem('10px')} ${pxToRem('4px')} ${pxToRem('16px')};
        border: ${props.status !== 'invalid'
          ? `${pxToRem('1px')} solid ${props.theme.colors.mainBlue}`
          : `${pxToRem('1px')} solid ${props.theme.colors.semantic.secondary}`};
      `;
      break;
    case 'form':
      style = css`
        width: ${pxToRem('431px')};
        height: ${pxToRem('56px')};
        margin: ${pxToRem('10px')};
        padding: 0 ${pxToRem('10px')} ${pxToRem('4px')} ${pxToRem('16px')};
        border: ${props.status !== 'invalid'
          ? `${pxToRem('1px')} solid ${props.theme.colors.mainBlue}`
          : `${pxToRem('1px')} solid ${props.theme.colors.semantic.secondary}`};
      `;
      break;
    default:
      break;
  }

  return style;
};

export const InputWrapper = styled.div`
  border-radius: ${pxToRem('6px')};
  padding: ${pxToRem('16px')};
  background-color: ${props => props.theme.colors.white};
  opacity: 0.8;
  ${props =>
      props.variant === 'editaccountdata' &&
      css`
        position: relative;
        opacity: ${props.value ? '1' : '0.4'};
      `}
    :hover {
    ${props =>
      props.status !== 'invalid' &&
      css`
      //  border: ${pxToRem('1px')} solid ${props.theme.colors.mainBlue};
      `}
  }
  display: flex;
  align-items: center;
  ${props =>
    props.status === 'invalid' &&
    css`
      border: ${pxToRem('1px')} solid ${props.theme.colors.semantic.secondary};
    `}
  ${props => getStyles(props)};
`;

export const IconPasswordWrapper = styled.div`
  cursor: pointer;
  color: ${props => props.theme.colors.white};
`;

export const InvalidLabel = styled.div`
  color: ${props => props.theme.colors.semantic.secondary};
  font-size: 1rem;
  font-family: inherit;
`;

export const IconElement = styled.div`
  font-size: ${pxToRem('24px')};
  ${props => getIconShowStyles(props)};
  ${props =>
    props.innerTooltip &&
    css`
      position: absolute;
      top: ${pxToRem('-15px')};
      left: ${pxToRem('-25px')};
    `}
`;

export const Placeholder = styled.label`
  position: absolute;
  font-family: 'OpenSans';
  font-size: ${pxToRem('11px')};
  color: ${props =>
    props.status === 'invalid'
      ? props.theme.colors.semantic.secondary
      : props.theme.colors.mainBlue};
  background-color: white;
  padding: 0 ${pxToRem('5px')};
  opacity: 0;
  z-index: -1;
  display: flex;
  ${props =>
    props.hasValue &&
    css`
      transform: translateX(${pxToRem('4.5px')}) translateY(-${pxToRem('26px')});
      opacity: 1;
      transition: all 250ms;
      font-weight: 600;
      z-index: 1;
    `};
`;
